(() => {
  const SHOP_NOW_FALLBACK = '/products/women-who-run-with-the-wolves-myths-and-stories-of-the-wild-woman-archetype';

  const getShopNowBasePath = () => {
    const headerLink = Array.from(document.querySelectorAll('.zen-site-header a[href]')).find((link) => {
      return link.textContent.trim().toLowerCase() === 'shop now';
    });

    return headerLink ? headerLink.getAttribute('href') || SHOP_NOW_FALLBACK : SHOP_NOW_FALLBACK;
  };

  const getShopNowUrl = () => {
    const currentUrl = new URL(window.location.href);
    const targetUrl = new URL(getShopNowBasePath(), window.location.origin);

    currentUrl.searchParams.forEach((value, key) => {
      if (key.indexOf('preview_') === 0 || key === 'pb' || key === '_fd') {
        targetUrl.searchParams.set(key, value);
      }
    });

    const theme = window.Shopify && window.Shopify.theme ? window.Shopify.theme : null;
    if (!targetUrl.searchParams.has('preview_theme_id') && theme && theme.role !== 'main' && theme.id) {
      targetUrl.searchParams.set('preview_theme_id', String(theme.id));
    }

    return targetUrl.pathname + targetUrl.search + targetUrl.hash;
  };

  const normalizeShopNowLinks = (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const targetUrl = getShopNowUrl();

    scope.querySelectorAll('a[href]').forEach((link) => {
      if (link.textContent.trim().toLowerCase() === 'shop now') {
        link.setAttribute('href', targetUrl);
        link.setAttribute('data-wisebound-shop-now', 'true');
      }
    });
  };

  const replaceText = () => {
    document.querySelectorAll('.novelle-marquee__item').forEach((item) => {
      if (item.textContent.trim().toLowerCase() === 'free express shipping') {
        item.textContent = '30-Day Money-Back Guarantee';
      }
    });

    document.querySelectorAll('[data-nz-product] .nz-bundle__meta').forEach((item) => {
      if (/free express shipping/i.test(item.textContent)) {
        item.textContent = item.textContent.replace(/free express shipping/gi, 'Shipping calculated at checkout');
      }
    });

    document.querySelectorAll('[data-nz-product] .nz-trust__item').forEach((item) => {
      const textNodes = Array.from(item.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
      textNodes.forEach((node) => {
        if (/free express shipping/i.test(node.textContent)) {
          node.textContent = node.textContent.replace(/free express shipping/gi, 'Order Tracking Available');
        }
      });
    });
  };

  const setup24HourOfferCountdown = (root = document) => {
    root.querySelectorAll('.wb-offer-bar').forEach((bar) => {
      if (bar.dataset.wb24HourReady === 'true') return;

      const oldHours = bar.querySelector('[data-wb-hours]');
      const oldMinutes = bar.querySelector('[data-wb-minutes]');
      const oldSeconds = bar.querySelector('[data-wb-seconds]');
      if (!oldHours || !oldMinutes || !oldSeconds) return;

      const hoursEl = oldHours.cloneNode(true);
      const minutesEl = oldMinutes.cloneNode(true);
      const secondsEl = oldSeconds.cloneNode(true);
      oldHours.replaceWith(hoursEl);
      oldMinutes.replaceWith(minutesEl);
      oldSeconds.replaceWith(secondsEl);

      bar.dataset.wb24HourReady = 'true';

      const durationMs = 24 * 60 * 60 * 1000;
      const themeId = window.Shopify && window.Shopify.theme && window.Shopify.theme.id
        ? window.Shopify.theme.id
        : 'default';
      const storageKey = `wisebound_offer_24h_${themeId}_${bar.id || 'main'}`;
      let endTime = NaN;

      try {
        endTime = Number.parseInt(window.localStorage.getItem(storageKey), 10);
      } catch (error) {
        endTime = NaN;
      }

      const saveEndTime = () => {
        try {
          window.localStorage.setItem(storageKey, String(endTime));
        } catch (error) {
          // Continue with an in-memory countdown when storage is unavailable.
        }
      };

      if (!Number.isFinite(endTime) || endTime <= Date.now()) {
        endTime = Date.now() + durationMs;
        saveEndTime();
      }

      const updateCountdown = () => {
        let remaining = Math.ceil((endTime - Date.now()) / 1000);

        if (remaining <= 0) {
          endTime = Date.now() + durationMs;
          saveEndTime();
          remaining = 24 * 60 * 60;
        }

        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      };

      updateCountdown();
      bar._wisebound24HourTimer = window.setInterval(updateCountdown, 1000);
    });
  };

  const runFixes = (root = document) => {
    normalizeShopNowLinks(root);
    replaceText();
    setup24HourOfferCountdown(root);
  };

  document.addEventListener('click', (event) => {
    const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || link.textContent.trim().toLowerCase() !== 'shop now') return;

    link.setAttribute('href', getShopNowUrl());
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runFixes(document), { once: true });
  } else {
    runFixes(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    runFixes(event.target || document);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target || document;
    root.querySelectorAll('.wb-offer-bar').forEach((bar) => {
      if (bar._wisebound24HourTimer) {
        window.clearInterval(bar._wisebound24HourTimer);
      }
    });
  });
})();
